import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ContactDetailsSession } from '../../api/models/contactDetailsSession';
import { LocationDetailsSession } from '../../api/models/locationDetailsSession';
import { AditionalEmail, NotificationDetailsSession } from '../../api/models/notificationDetailsSession';
import { PickupDetailsSession } from '../../api/models/pickupDetailsSession';
import { PlacardConfirmationSession, UploadedImageInformation } from '../../api/models/placardConfirmationSession';
import { PlacardDetailsSession } from '../../api/models/placardDetailsSession';
import { PlacardLocationSession } from '../../api/models/PlacardLocationSession';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, ConfirmationFlowConstants, RouteURLConstants, ServiceURLConstants, CommonConstants, CONTINENTAL_REGIONS, EMAIL_LANGUAGE_POSVALUE } from '../../constants/upplm.constants';
import { AvailableDayAndService, PickupTypePlan } from '../../interface/upplm.pickupdetails';
import { Contact, PickupDetails, PlacardDetails, PlacardInformation, PlacardLocation, PlacardVerification } from '../../interface/upplm.placardInformation';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { SendApproveService } from '../../services/upplm.sendApprove.service';
import { SendApproveResponse } from '../../api/models/approveResponse';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';
import { PlacardLocationStatusResponse } from '../../interface/upplm.placardLocation';
import { PLACARD_STATUS } from '../../constants/upplm.constants.dashboard';
import { PLACARD_LOCATION_DESCRIPTION } from '../../constants/upplm.constants.placardlocation';
import { UPPLM_TRANSLATIONS } from '../../constants/upplm.constants.translations';


@Component({
    selector: 'approve',
    template: require('./approve.component.html'),
    styles: ['a{cursor:pointer} ']
})

export class ApproveComponent implements OnInit, AfterViewInit {
    public placardID: string = '';
    public paramsUrl: string = '?loc=en_US&placardid=';
    public sessionData: SessionResponse;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = true;
    public makePrimaryContact: boolean = true;
    public arrayCatalog0: any;
    public arrayCatalog1: any;
    Errors: any[];
    public messagesErrorServer: string = '';
    sendApproveError: string = '';
    public urlImage: string = '';
    public toggle: string = '';
    public formatedStartDate: string = '';
    paramsUrlCatalog: string = '/PICKUP_LOCATION/PLACARD_LOCATION';
    pickupLocationValue: any;
    placardLocationValue: any;
    public isApproved: boolean = false;
    public metalBoxShow: string = '';
    titleText: string = '';
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    globalRegion: string = 'NA';
    PosEmailValue: string = '';

    constructor(private router: Router,
        public _activatedRoute: ActivatedRoute,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        private _sessionService: UpplmSessionService,
        private _sendApproveService: SendApproveService) {
    }

    ngOnInit() {
        this.titleText = 'Manage UPS<sup>'.concat(String.fromCharCode(174)).concat('</sup> Pickup Point Locations');
    }

    ngAfterViewInit() {

        setTimeout(() => {
            this.getCatalog();
            this.isInitialLoadding = true;
            this.placardID = this._activatedRoute.snapshot.queryParamMap.get('placardid')
            if (this.placardID === null) {
                this.placardID = this._commonService.getUrlParameter("placardid");
            }
            this.placardID = this.placardID.toUpperCase();

            this.sessionData = this._sessionService.sessionData;

            let request = this.createSessionRequest(false);
            let requestImg: any;
            if (request.placardConfirmation) {
                if (request.placardConfirmation.placardImage) {
                    requestImg = request.placardConfirmation.placardImage;
                    delete request.placardConfirmation.placardImage;
                }
            }
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                this.sessionData = response;
                if (this.placardID === null || this.placardID.length < 1) {
                    this.placardID = response.placardID;
                }


                if (response.placardConfirmation !== null) {
                    response.placardConfirmation.placardImage = requestImg;
                }


                this._sessionService.mapSessionResponse(response);
                if (!this.sessionData.comesFromReview) {
                    this.getPlacardInformation();
                } else {
                    this.globalRegion = this.getGlobalRegion(this.sessionData.locationDetails.countryKey);
                    this.PosEmailValue = this.getPosEmailValue(this.sessionData.locationDetails.countryKey);
                    this.toggle = this.sessionData.placardDetails.togglePlacard ? 'Yes' : 'No';
                    this.getImageData();
                    this.isInitialLoadding = false;
                }
            });

        }, 1000);

        this.ConfirmationBoxModal.setProperties({
            title: ConfirmationFlowConstants.SESSION_TEMED_OUT_TITLE
        });
        this.SessionErrorModal.setProperties({
            title: ConfirmationFlowConstants.SERVICE_ERROR
        });
    }

    getImageData() {
        if (this.sessionData.placardConfirmation) {
            if (this.sessionData.placardConfirmation.placardImage) {
                this.urlImage = this.sessionData.placardConfirmation.placardImage.contents;
                let found = this.urlImage.search('data');
                if (found === -1) {
                    this.urlImage = 'data:' + this.sessionData.placardConfirmation.placardImage.extension + ';base64,' + this.sessionData.placardConfirmation.placardImage.contents;
                }
            }
        }
    }

    goto(target) {
        this.validateSessionAndNavigate(target)
    }

    click: boolean = false;

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this.ConfirmationBoxModal.open();
        }
        else {
            if (!this.click) {
                this.click = true;

                let request: any = this.createSessionRequest(true);
                let requestImg: any;
                if (request.placardConfirmation) {
                    if (request.placardConfirmation.placardImage) {
                        requestImg = request.placardConfirmation.placardImage;
                        delete request.placardConfirmation.placardImage;
                    }
                }

                this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                    if (response.commonResponse.isSuccess) {
                        response.placardConfirmation.placardImage = requestImg;
                        this._sessionService.mapSessionResponse(response);
                        this.router.navigateByUrl(this.getTarget(target));
                    }
                });
            }
        }
    }

    getTarget(target: string) {
        switch (target) {
            case 'placardpending':
                return RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.placardID);
            case 'placardlocation':
                return RouteURLConstants.UPPLM_VIEW_PLACARD_LOCATION_ROUTE + this.paramsUrl.concat(this.placardID);
        }
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.placardStatus = this.sessionData.placardStatus;
        request.locationDetails = this.sessionData.locationDetails;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.placardConfirmation = this.sessionData.placardConfirmation;
        request.placardLocation = this.sessionData.placardLocation;
        request.lastTimeSessionReqired = new Date().toString();
        if (update) {
            request.placardID = this.placardID;
            request.comesFromReview = true;
            request.isApproved = this.isApproved;
            this.metalBoxShow = this.sessionData.placardLocation.metalBoxInd.toString().toUpperCase() == 'FALSE' ? "No" : "Yes";
        }
        else {
            request.placardID = this.sessionData.placardID;
            request.comesFromReview = this.sessionData.comesFromReview;
            if (this.sessionData.placardLocation != null) {
                if (this.sessionData.placardLocation.metalBoxInd != null) {
                    this.metalBoxShow = this.sessionData.placardLocation.metalBoxInd.toString().toUpperCase() == 'FALSE' ? "No" : "Yes";
                }
            }
        }
        return request;
    }

    getPlacardInformation() {
        if (this.placardID === "") {
            document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
        }
        else {
            let url = this._commonService.createURL(ServiceURLConstants.GET_PLACARD_INFORMATION + this.placardID, ApiErrorCode.GET_PLACARD_INFORMATION);
            this._apiService.PostServiceAPI(url, null).subscribe((response: PlacardInformation) => {
                if (response.errors) {
                    document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
                }
                else {

                    if (response.placardStatus === PLACARD_STATUS.CREATED_2 || response.placardStatus === PLACARD_STATUS.EXPIRED_2) {
                        //Placard Status
                        this.setPlacardStatus(response.placardStatus);

                        // Location Details  
                        this.sessionData.locationDetails = new LocationDetailsSession();
                        this.sessionData.locationDetails.companyName = response.companyName;
                        this.sessionData.locationDetails.address1 = response.confirmedPlacardInformation.locationDetails.address.addressLine1;
                        this.sessionData.locationDetails.city = response.confirmedPlacardInformation.locationDetails.address.cityTown;
                        this.sessionData.locationDetails.countryKey = response.confirmedPlacardInformation.locationDetails.address.countryCode;
                        this.globalRegion = this.getGlobalRegion(this.sessionData.locationDetails.countryKey);
                        this.sessionData.locationDetails.postal = response.confirmedPlacardInformation.locationDetails.address.postalCode;
                        this.sessionData.locationDetails.state = response.confirmedPlacardInformation.locationDetails.address.stateProvince;
                        this.sessionData.locationDetails.clientKey = response.confirmedPlacardInformation.locationDetails.clientKey;
                        this.sessionData.locationDetails.nickname = response.confirmedPlacardInformation.locationDetails.nickname;

                        //Contact Details
                        this.setContactDetails(response.confirmedPlacardInformation.contactDetails);

                        //Placard Details
                        this.setPlacardDetails(response.confirmedPlacardInformation.placardDetails);

                        //Pickup Details
                        this.setPickupDetails(response.confirmedPlacardInformation.pickupDetails);

                        //Notification Details
                        this.PosEmailValue = this.getPosEmailValue(this.sessionData.locationDetails.countryKey);
                        this.sessionData.notificationDetails = new NotificationDetailsSession();
                        this.sessionData.notificationDetails.aditionalEmails = this.setNotificationDetails(response.confirmedPlacardInformation.notifications);

                        //Placard Verification 
                        this.setPlacardVerification(response.confirmedPlacardInformation.placardVerification, response.placardId, response.confirmed);

                        //Placard Location
                        this.setPlacardLocation(response.confirmedPlacardInformation.placardLocation);
                    }
                    else {
                        document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
                    }
                }
            });
        }
    }

    getGlobalRegion(countryCode: string): string {
       return countryCode ? this._commonService.getRegionCountry(this.sessionData.locationDetails.countryKey) : CONTINENTAL_REGIONS.NA;
    }
    setPickupDetails(pickupDetails: PickupDetails) {
        this.sessionData.pickupDetails = new PickupDetailsSession();
        this.sessionData.pickupDetails.pPlanTypes = Array<PickupTypePlan>();
        var PlanTypes = new PickupTypePlan();
        PlanTypes.pickupPlanType = pickupDetails.pickupPlanType;
        this.sessionData.pickupDetails.pPlanTypes.push(PlanTypes);
        this.sessionData.pickupDetails.availableDays = Array<AvailableDayAndService>();

        pickupDetails.selectedDays.forEach(function (pickup) {
            let availableDays = new AvailableDayAndService
            availableDays.dayOfWeekCode = this.mappingDay(pickup.dayOfWeekCode);
            availableDays.selectedPreferredTime = pickup.selectedPreferredTime;
            availableDays.selectedLatestTime = pickup.selectedLatestTime;
            this.sessionData.pickupDetails.availableDays.push(availableDays);
        }, this);
        
    }

    setPlacardStatus(placardStatus: string) {
        this.sessionData.placardStatus = placardStatus === PLACARD_STATUS.CREATED_2 ? PLACARD_STATUS.CREATED : PLACARD_STATUS.EXPIRED;
    }

    setPlacardDetails(placardDetails: PlacardDetails) {
        this.sessionData.placardDetails = new PlacardDetailsSession();
        this.sessionData.placardDetails.togglePlacard = placardDetails.locationType == "Multi Location" ? true : false;
        this.toggle = this.sessionData.placardDetails.togglePlacard ? 'Yes' : 'No';
        this.sessionData.placardDetails.placardSizeKey = placardDetails.placardSizeKey;
        this.sessionData.placardDetails.placardTypekey = placardDetails.placardTypeKey;
    }

    setPlacardLocation(placardLocation: PlacardLocation) {
        this.sessionData.placardLocation = new PlacardLocationSession();
        this.sessionData.placardLocation.additionalLocationDetails = placardLocation.additionalLocationDetails;
        this.sessionData.placardLocation.lockCombination = placardLocation.lockCombination;
        if (placardLocation.pickupLocation == this.arrayCatalog0.elements[0].key) {
            this.sessionData.placardLocation.pickupLocation = PLACARD_LOCATION_DESCRIPTION.INSIDE;
        } else if (placardLocation.pickupLocation == this.arrayCatalog0.elements[1].key) {
            this.sessionData.placardLocation.pickupLocation = PLACARD_LOCATION_DESCRIPTION.OUTSIDE;
        } else {
            this.sessionData.placardLocation.pickupLocation = placardLocation.pickupLocation;
        }

        this.sessionData.placardLocation.placardLocation = placardLocation.placardLocation;
        //previous
        this.sessionData.placardLocation.metalBoxInd = placardLocation.metalBoxInd.toString().toUpperCase() == 'TRUE' ? true : false;
        this.metalBoxShow = this.sessionData.placardLocation.metalBoxInd.toString().toUpperCase() == 'FALSE' ? "No" : "Yes";
        this.getCatalgosMapping();
        this.isInitialLoadding = false;
    }

    setPlacardVerification(placardVerification: PlacardVerification, placardId: string, confirmed: boolean) {
        this.sessionData.placardConfirmation = new PlacardConfirmationSession();
        if (placardVerification) {
            if (placardVerification.placardImage) {
                this.sessionData.placardConfirmation.placardImage = new UploadedImageInformation();
                this.sessionData.placardConfirmation.placardImage = placardVerification.placardImage;
                this.sessionData.placardConfirmation.placardImage.name = placardVerification.placardImage.name;
                this.sessionData.placardConfirmation.placardImage.extension = placardVerification.placardImage.extension;
                this.sessionData.placardConfirmation.placardImage.fullName = `${this.sessionData.placardConfirmation.placardImage.name}.${this.sessionData.placardConfirmation.placardImage.extension}`;
                this.sessionData.placardConfirmation.placardImage.contents = placardVerification.placardImage.contents;
                if (this.sessionData.placardConfirmation.placardImage != null) {
                    this.getURLPicture();
                }
            }
            this.sessionData.placardConfirmation.pickupStartDate = placardVerification.pickupStartDate;
            this.sessionData.placardConfirmation.customerFacingStartDate = placardVerification.customerFacingStartDate;
            this.sessionData.placardConfirmation.placardId = placardId;
            this.sessionData.placardConfirmation.placardDisplayed = confirmed;
        }
    }

    setContactDetails(contactDetails: Contact[]) {
        this.sessionData.contactDetails = new ContactDetailsSession();
        var contactDetails02 = new ContactDetailsSession();
        var contactDetails01 = new ContactDetailsSession();

        for (let i in contactDetails) {
            if (contactDetails[i].contactType == '02') { //02 = primaryContact
                contactDetails02.email = contactDetails[i].email;
                contactDetails02.name = contactDetails[i].name;
                contactDetails02.phone = contactDetails[i].phone;
                contactDetails02.ext = contactDetails[i].phoneExt;
            } else if (contactDetails[i].contactType == '01') { //01 = requestor
                contactDetails01.email = contactDetails[i].email;
                contactDetails01.name = contactDetails[i].name;
                contactDetails01.phone = contactDetails[i].phone;
                contactDetails01.ext = contactDetails[i].phoneExt;
            }
        }

        if (contactDetails02 != null && contactDetails01 != null) {
            if (contactDetails02.name == contactDetails01.name && contactDetails02.email == contactDetails01.email && contactDetails02.phone == contactDetails01.phone && contactDetails02.ext == contactDetails01.ext) {
                this.sessionData.contactDetails.email = contactDetails02.email;
                this.sessionData.contactDetails.name = contactDetails02.name;
                this.sessionData.contactDetails.phone = contactDetails02.phone;
                this.sessionData.contactDetails.ext = contactDetails02.ext;
                this.sessionData.contactDetails.makePrimaryContact = true;
            } else {
                this.sessionData.contactDetails.email = contactDetails01.email;
                this.sessionData.contactDetails.name = contactDetails01.name;
                this.sessionData.contactDetails.phone = contactDetails01.phone;
                this.sessionData.contactDetails.ext = contactDetails01.ext;
                this.sessionData.contactDetails.primaryEmail = contactDetails02.email;
                this.sessionData.contactDetails.primaryName = contactDetails02.name;
                this.sessionData.contactDetails.primaryPhone = contactDetails02.phone;
                this.sessionData.contactDetails.primaryExt = contactDetails02.ext;
                this.sessionData.contactDetails.makePrimaryContact = false;

            }
        } else {
            this.sessionData.contactDetails.email = contactDetails02.email;
            this.sessionData.contactDetails.name = contactDetails02.name;
            this.sessionData.contactDetails.phone = contactDetails02.phone;
            this.sessionData.contactDetails.ext = contactDetails02.ext;
            this.sessionData.contactDetails.makePrimaryContact = true;

        }
    }

    setNotificationDetails(notifications: Contact[]): AditionalEmail[] {
        let aditionalEmails: AditionalEmail[] = [];
        if (notifications) {
            notifications.forEach(element => {
                let additionalEmail = new AditionalEmail();
                additionalEmail.email = element.email;
                aditionalEmails.push(additionalEmail);
            }, this);
            return aditionalEmails;
        }
    }

    getPosEmailValue(countryKey: string): string {
        const data = EMAIL_LANGUAGE_POSVALUE.find(x => x.countryCode === countryKey);
        const language = UPPLM_TRANSLATIONS.find(x => x.key === data.language).default;
        return `${data.countryCode} ${language}`;
    }

    getURLPicture() {
        if (this.sessionData.placardConfirmation) {
            if (this.sessionData.placardConfirmation.placardImage) {
                this.urlImage = 'data:' + this.sessionData.placardConfirmation.placardImage.extension + ';base64,' + this.sessionData.placardConfirmation.placardImage.contents;
            }
        }
    }

    mappingDay(day: string) {
        var formatDay;

        if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[0].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[0];
        } else if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[1].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[1];
        } else if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[2].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[2];
        } else if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[3].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[3];
        } else if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[4].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[4];
        } else if (day.toUpperCase() == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT[5].toUpperCase()) {
            formatDay = CommonConstants.ORDERED_DAYS_OF_WEEK[5];
        } else {
            formatDay = day;
        }
        return formatDay;
    }

    getCatalgosMapping() {
        this.pickupLocationValue = this.arrayCatalog0.elements.filter(x => x.value === this.sessionData.placardLocation.pickupLocation)[0].key;
        this.placardLocationValue = this.arrayCatalog1.elements.filter(x => x.value.toUpperCase() === this.sessionData.placardLocation.placardLocation.toUpperCase())[0].key;
        this.sessionData.placardLocation.pickupLocationKey = this.pickupLocationValue;
        this.sessionData.placardLocation.placardLocationKey = this.placardLocationValue;
    }

    getCatalog() {
        var url = ServiceURLConstants.GET_CATALOG + this.paramsUrlCatalog;
        this._apiService.getCatalogData(this._commonService.createURL(url, ApiErrorCode.CREATE_PLACARD_CONFIRMATION)).toPromise()
            .then((response: PlacardLocationStatusResponse) => {
                if (response.errors !== null) {
                    if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                        this.messagesErrorServer = response.errors[0].message;
                        this.openModal();
                        return;
                    }
                }

                let catalogs: any = [];
                if (response.catalogs !== null) {
                    response.catalogs.forEach(element => {
                        catalogs.push(element);
                    });
                }
                var js = JSON.stringify(catalogs);
                var catalog = JSON.parse(js);
                this.arrayCatalog0 = catalog[0];
                this.arrayCatalog1 = catalog[1];
            })
    }

    nextPage() {

        if (!this._sessionService.isValidSession()) {
            this.ConfirmationBoxModal.open();
        } else {
            this.displayErrors();
            if (this.Errors.length === 0) {
                if (!this.isLoadding) {
                    this.isLoadding = true;
                    let url = this._commonService.createURL(ServiceURLConstants.SEND_APPROVE + this.placardID, ApiErrorCode.SEND_APPROVE);
                    let sessionRequest = this.createSessionRequest(false);
                    delete sessionRequest.placardID;
                    this._sendApproveService.sendApprove(url, sessionRequest).subscribe((response: SendApproveResponse) => {
                        if (response.errors) {
                            this.sendApproveError = response.errors[0].message;
                            this.messagesErrorServer = response.errors[0].message;
                            this.isLoadding = false;
                            this.openModal();
                        } else {
                            this.setSessionApproveData(response.pickupPointStatus, response.confirmed);
                        }
                    });
                }
            }
        }
    }

    setSessionApproveData(pickupPointStatus: string, confirmed: boolean) {
        if (pickupPointStatus === PLACARD_STATUS.PENDING) {
            this.isApproved = confirmed;
            let requestSessionisApproved = this.createSessionRequest(true);
            let requestImg = requestSessionisApproved.placardConfirmation.placardImage;
            delete requestSessionisApproved.placardConfirmation.placardImage;
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), requestSessionisApproved).subscribe((resp: SessionResponse) => {
                if (resp.commonResponse.isSuccess && resp.key) {
                    this.sessionData = resp;
                    resp.placardConfirmation.placardImage = requestImg;
                    this._sessionService.mapSessionResponse(resp);
                    let target = RouteURLConstants.UPPLM_VIEW_APPROVE_CONFIRMED_ROUTE;
                    this._commonService.url = target;
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    displayErrors() {
        this.Errors = [];
    }

    public openPicture() {
        var newTab = window.open();
        let found = this.urlImage.search('data');
        if (found > 0) {
            this.urlImage = 'data:' + this.sessionData.placardConfirmation.placardImage.extension + ';base64,' + this.sessionData.placardConfirmation.placardImage.contents;
        }
        newTab.document.body.innerHTML = '<img src="' + this.urlImage.trim() + '"' + ' width="80%" height="80%">';
    }

    public openModal() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
    }
}